'use strict';

import * as _ from 'lodash-es';

(function () {

  angular
    .module('specsguardApp')
    .factory('Datastructure', Datastructure);

  Datastructure.$inject = ['$resource'];

  function Datastructure ($resource) {
    return $resource('/api/datastructure/:levelPrefix/:level/:id',
      { id: '@id', level: '@level' },
      {
        getFull: {
          method: 'GET',
          params: {},
          isArray: true
        },

        getFullFlat: {
          method: 'GET',
          params: {},
          isArray: true,
          transformResponse: function (datastructure) {
            var inputs = [];
            _.each(JSON.parse(datastructure), function (level, levelKey) {
              _.each(level.modules, function (module, moduleKey) {
                _.each(module.categories, function (category, categoryKey) {
                  _.each(category.inputs, function (input, inputKey) {
                    input.level = level.name;
                    input.module = module.name;
                    input.category = category.name;
                    // input.name = input.name
                    // input.treeLevel = 3
                    inputs.push(input);
                  });
                });
              });
            });
            return inputs;
          }
        },

        // getLevel: { method: 'GET', params: {}, isArray:true },

        createLevel: {
          method: 'POST',
          params: {
            level: 'level'
          }
        },

        createModule: {
          method: 'POST',
          params: {
            level: 'discipline'
          }
        },

        createCategory: {
          method: 'POST',
          params: {
            level: 'subdiscipline'
          }
        },

        createInput: {
          method: 'POST',
          params: {
            level: 'input'
          }
        },

        getInput: {
          method: 'GET',
          params: {
            id: 1,
            levelPrefix: 'level',
            level: 'input'
          }
        },

        updateModule: {
          method: 'PUT',
          params: {
            level: 'discipline'
          }
        },
        updateCategory: {
          method: 'PUT',
          params: {
            level: 'subdiscipline'
          }
        },
        updateInput: {
          method: 'PUT',
          params: {
            level: 'input'
          }
        }
      });
  }

})();
